import React, { useState } from 'react'
import { Tooltip } from '@mui/material'

import Icon from '@/components/Icon'
import styles from '../styles.module.scss'

interface CopyButtonProps {
  text: string
  label: string
}

const CopyButton = ({ text, label }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Tooltip
      title={copied ? 'Copied!' : label}
      {...(copied ? { open: true } : {})}
      arrow
      placement="top"
    >
      <button
        type="button"
        className={styles.copyButton}
        aria-label={label}
        onClick={handleCopy}
      >
        <Icon name="clipboard" className="" aria-hidden="true" />
      </button>
    </Tooltip>
  )
}

export default CopyButton
